var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wallet_black_28dp-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 328,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "0403\\u66F4\\u65B0--my-balance\\u5165\\u53E3",
    transform: "translate(-1070.000000, -30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-21",
    transform: "translate(0.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-20",
    transform: "translate(42.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-2\\u5907\\u4EFD-2",
    transform: "translate(1020.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wallet_black_28dp-2",
    transform: "translate(8.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,4.66666667 L7,4.66666667 C4.42166667,4.66666667 2.33333333,6.755 2.33333333,9.33333333 L2.33333333,18.6666667 C2.33333333,21.245 4.42166667,23.3333333 7,23.3333333 L21,23.3333333 C23.5783333,23.3333333 25.6666667,21.245 25.6666667,18.6666667 L25.6666667,9.33333333 C25.6666667,6.755 23.5783333,4.66666667 21,4.66666667 Z M18.83,16.065 C18.55,16.2983333 18.165,16.3916667 17.8033333,16.2983333 L4.84166667,13.125 C5.19166667,12.2733333 6.02,11.6666667 7,11.6666667 L21,11.6666667 C21.7816667,11.6666667 22.47,12.0633333 22.9016667,12.6466667 L18.83,16.065 Z M7,7 L21,7 C22.2833333,7 23.3333333,8.05 23.3333333,9.33333333 L23.3333333,9.975 C22.645,9.57833333 21.8516667,9.33333333 21,9.33333333 L7,9.33333333 C6.14833333,9.33333333 5.355,9.57833333 4.66666667,9.975 L4.66666667,9.33333333 C4.66666667,8.05 5.71666667,7 7,7 Z",
    id: "\\u5F62\\u72B6",
    fill: "currentColor",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceIcon);
export default __webpack_public_path__ + "static/media/balance-icon.10f7763c60683a7b3ee9bb0b2ce62529.svg";
export { ForwardRef as ReactComponent };